//JUST A NICE FORCE DIRECTED GRAPH
//NO INTERACTION, NO RENDERING

angular.module('mtic.components.modules').service('VerletSystemService', function(PIXI, $log) {


  return function VerletSystem() {

    //Fewer iterations -> looser simulation
    //More iterations -> rigid/snappier simulation (at performance cost)
    var NUM_ITERATIONS = 5;
    var CONSTRAINT_LENGTH = 60;

    var ENABLED = true;

    //a map of VerletBody
    var bodies = {};
    var segments = {
      dash: [],
      solid: []
    };

    this.clear = function() {
      this.deactivateAllBodies();
      bodies = {};
      segments = {
        dash: [],
        solid: []
      };

    }

    var getBody = function(key) {
        return bodies[key];
      }
      //an array of the active verlet bodies
    var active_bodies = [];

    //A body used in verlet simulation
    var VerletBody = function(id, sprite, constraints, dash) {
      var thiz = this;
      this.constraints = constraints;
      this.dash = dash;
      thiz.id = id;
      thiz.active = true;
      // this.sprite.alpha = 0;
      this.position = sprite.position;
      this.sprite = sprite;

      this.last_pos = {
        x: this.position.x,
        y: this.position.y
      }
      this.saved_pos = {
        x: this.position.x,
        y: this.position.y
      }
      this.setPosition = function(x, y) {
        thiz.position.x = thiz.last_pos.x = thiz.saved_pos.x = x;
        thiz.position.y = thiz.last_pos.y = thiz.saved_pos.y = y;
      }
    }

    var updateUnlocks = function(id, constraints) {
        for (var i = 0; i < bodies.length; i++) {
          // if (bodies[id])
        }
      }
      //Every body applies a repel force to every other body
    var addRepelForces = function(strength) {
      if (!ENABLED)
      {
        return;
      }
        var body;
        for (var i = 0; i < active_bodies.length; i++) {
          body = getBody(active_bodies[i]);
          for (var n = 0; n < active_bodies.length; n++) {
            //Doesn't repel itself
            if (i === n) {
              continue;
            }
            var other = getBody(active_bodies[n]);
            var dir = {
              x: body.position.x - other.position.x,
              y: body.position.y - other.position.y
            };
            //This was supposed to be a simple negative gravity calculation
            //But I messed up and didn't do it right, so it is now some magic math until I get back to it
            //Apply a force between items that are too close together, pushing them apart
            var dist = Math.pow(dir.x, 2) + Math.pow(dir.y, 2);
            if (dist < Math.pow(600, 2)) {
              dist /= strength;
              dir = {
                x: dir.x / dist,
                y: dir.y / dist
              }
              if (isNaN(dir.x) || isNaN(dir.y)) {
                continue;
              }
              body.last_pos.x += dir.x;
              body.last_pos.y += dir.y;
              other.last_pos.x -= dir.x;
              other.last_pos.y -= dir.y;
            }
          }
        }
      }
      //loop over every body, adjusting the positions to try to satisfy every spring constraint created in this.hookUpConstraints()
      //We're already doing the math necessary to draw the lines, so generate that info here if GENERATE_LINES is true
    var simulateConstraints = function(GENERATE_LINES) {
        var body;
        if (GENERATE_LINES) {
          segments.dash = [];
          segments.solid = [];
        }
        //every body
        for (var i = 0; i < active_bodies.length; i++) {
          body = getBody(active_bodies[i]);
          // $log.log('verlet body : ', body.id, body.constraints)
          var dist = 0;
          //loops over every one of its constraints
          for (var n = 0; n < body.constraints.length; n++) {

            //Ignore deactivated items
            if (active_bodies.indexOf(body.constraints[n]) === -1) {
              continue;
            }
            var other = getBody(body.constraints[n]);
            //Vector between two bodies
            var dir = {
              x: body.position.x - other.position.x,
              y: body.position.y - other.position.y
            };


            //Magnitude of the vector between two bodies
            dist = Math.sqrt(Math.pow(dir.x, 2) + Math.pow(dir.y, 2));

            //Difference between current distance and desired constraint distance
            var diff = CONSTRAINT_LENGTH - dist;

            //If this isn't perfectly satisfying the constraint, add some force
            if (diff !== 0) {
              //normalize direction
              dir = {
                x: dir.x / dist,
                y: dir.y / dist
              }
              if (isNaN(dir.x) || isNaN(dir.y)) {
                continue;
              }



              if (GENERATE_LINES) {

                /* EVERYTHING IS A SOLID LINE FOR NOW
                if (other.dash && body.constraints[n] !== 'mtic_g78_m2_diag' && body.constraints[n] !== 'mtic_g78_m1_diag') {
                  var dot_pos = {
                    x : body.position.x + dir.x * -50,
                    y : body.position.y + dir.y * -50
                  };

                  for(var j = 0; j < dist - 75; j += 35)
                  {
                    segments.dash.push({
                      x : dot_pos.x,
                      y : dot_pos.y
                    });
                    dot_pos.x += dir.x * -35;
                    dot_pos.y += dir.y * -35;
                  }
                } else*/
                {
                  segments.solid.push({
                    start: {
                      x: body.position.x,
                      y: body.position.y
                    },
                    end: {
                      x: other.position.x,
                      y: other.position.y
                    },
                    id: body.id,
                    constraints: body.constraints
                  })
                }
              }



              //We're not actually maintaining a 'velocity' variable
              //Verlet Integration just stores the current position and the last position and derives velocity from (current_pos - last_pos)
              //So to update the 'velocity' we just change what the last position is stored as
              diff /= 2;
              body.last_pos.x += dir.x * diff;
              body.last_pos.y += dir.y * diff;
              other.last_pos.x -= dir.x * diff;
              other.last_pos.y -= dir.y * diff;
            }
          }
        }
      }
      //Actually move the bodies.
      //Verlet Integration does this by finding the inertia (current position minus last position) and adding it to the current position
    var moveBodies = function() {
      if (!ENABLED)
      {
        return;
      }
      var body;
      for (var i = 0; i < active_bodies.length; i++) {
        body = getBody(active_bodies[i]);
        //first store the current position
        body.saved_pos.x = body.position.x;
        body.saved_pos.y = body.position.y;
        //move based on position last frame (inertia)
        var damp = 0.16;
        if (Math.abs(body.position.x - body.last_pos.x) > 5 || Math.abs(body.position.y - body.last_pos.y) > 5)
        {

          body.position.x -= (body.position.x - body.last_pos.x) * damp;
          body.position.y -= (body.position.y - body.last_pos.y) * damp;
        }
        //store current position for next frame
        body.last_pos.x = body.saved_pos.x;
        body.last_pos.y = body.saved_pos.y;
      }
    }
    this.setConstraintLength = function(val) {
      if (val === undefined) {
        CONSTRAINT_LENGTH = 60;
      } else {
        CONSTRAINT_LENGTH = val;
      }
    }

    this.toggle = function(val) {
      if (val === undefined) {
        ENABLED = !ENABLED;
      } else {
        ENABLED = val;
      }
    }

    this.getCurrentEnabledStatus = function(){
      return ENABLED;
    }

    this.getLineSegments = function() {
      return segments;
    }
    this.getBody = function(id) {
      return bodies[id];
    }

    this.createBody = function(id, sprite, constraints, dash) {
        var body = new VerletBody(id, sprite, constraints, dash);
        bodies[id] = body;
        active_bodies.push(id);
        return body;
      }
      //Loop to update the bodies
    this.update = function() {
        for (var i = 0; i < NUM_ITERATIONS; i++) {
          addRepelForces(800);
          moveBodies();
          simulateConstraints(i === NUM_ITERATIONS - 1);
        }
      }
      //remove a body from the active_bodies list. return true if it exists
    this.deactivateBody = function(id, hide_sprite) {
      var index = active_bodies.indexOf(id);
      if (index > -1) {
        active_bodies.splice(index, 1);
        if (hide_sprite) {
          getBody(id).sprite.visible = false;
        }
        return true;
      }
      return false;
    }
    this.deactivateAllBodies = function(hide_sprites) {
      while (active_bodies.length > 0) {
        this.deactivateBody(active_bodies[0], hide_sprites);
      }
    }

    //add a body to the active_bodies list. return true if it exists
    this.activateBody = function(id, show_sprite) {
        var body = getBody(id);
        if (body !== null && body !== undefined) {
          if (active_bodies.indexOf(id) === -1) {
            active_bodies.push(id);
          }

          //Reset the forces on the sprite
        //  body.setPosition(body.sprite.x, body.sprite.y);

          if (show_sprite) {
            getBody(id).sprite.visible = true;
          }
          return true;
        }
        $log.debug('woah no body: ' + id);
        return false;
      }
      //return an array of PIXI.Sprite
    this.getActiveSprites = function() {
      var sprites = [];
      for (var i = 0; i < active_bodies.length; i++) {
        sprites.push(getBody(active_bodies[i]).sprite);
      }
      return sprites;
    }

    this.getActiveSlugs = function(){
      return active_bodies;
    }


  }

})
